export default __webpack_public_path__ + "static/media/con_chassis04.b7534b62.jpg";